import React, { useState } from "react";
import { InteractionModalContainer } from ".";
import { Row, Col } from "react-bootstrap";
import usePoolToken from "../../hooks/usePoolToken";
import RiskMetrics from "../RiskMetrics";
import InputAmount from "../InputAmount";
import InteractionButton from "../InteractionButton";
import useApprove from "../../hooks/useApprove";
import useRepay from "../../hooks/useRepay";
import { useToBigNumber } from "../../hooks/useConverter";
import useGenericCall from "../../hooks/useGenericCall";
import { useOnchainAccountBorrowable } from "../../hooks/useOnchain";
import { ApprovalType, PoolTokenType } from "impermax-sdk";

/**
 * Props for the deposit interaction modal.
 * @property show Shows or hides the modal.
 * @property toggleShow A function to update the show variable to show or hide the Modal.
 */
export interface RepayInteractionModalProps {
  show: boolean;
  toggleShow(s: boolean): void;
}

/**
 * Styled component for the norrow modal.
 * @param param0 any Props for component
 * @see RepayInteractionModalProps
 */
export default function RepayInteractionModal({show, toggleShow}: RepayInteractionModalProps) {
  const poolTokenType = usePoolToken();
  const [val, setVal] = useState<number>(0);

  const data = useGenericCall(useOnchainAccountBorrowable(), async onchainAccountBorrowable => {
    const availableBalance = await onchainAccountBorrowable.getAvailableBalance();
    const borrowed = await onchainAccountBorrowable.getBorrowed();
    return {
      symbol: await (await onchainAccountBorrowable.getPoolToken().getOffchainPoolToken()).getSymbol(),
      maxRepayable: Math.min(availableBalance, borrowed),
    }
  });

  const amount = useToBigNumber(val);
  const invalidInput = data && val > data.maxRepayable;
  const [approvalState, onApprove,] = useApprove(ApprovalType.UNDERLYING, amount, invalidInput);
  const [repayState, repay] = useRepay(approvalState, amount, invalidInput);
  const onRepay = async () => {
    await repay();
    setVal(0);
    toggleShow(false);
  }

  if (!data) return null;

  return (
    <InteractionModalContainer title="Repay" show={show} toggleShow={toggleShow}><>
      <RiskMetrics
        changeBorrowedA={poolTokenType == PoolTokenType.BorrowableA ? -val : 0}
        changeBorrowedB={poolTokenType == PoolTokenType.BorrowableB ? -val : 0}
      />
      <InputAmount 
        val={val}
        setVal={setVal}
        suffix={data.symbol}
        maxTitle={'Available'}
        max={data.maxRepayable}
      />
      <Row className="interaction-row">
        <Col xs={6}>
          <InteractionButton name="Approve" onCall={onApprove} state={approvalState} />
        </Col>
        <Col xs={6}>
          <InteractionButton name="Repay" onCall={onRepay} state={repayState} />
        </Col>
      </Row>
    </></InteractionModalContainer>
  );
}